import { SoftwareFeaturePage } from './SoftwareFeaturePage';

export function RoleFitPage() {
  return (
    <SoftwareFeaturePage content={{
      eyebrow: 'Software — Explainable Role-Fit',
      title: "Show the hiring manager why these 5 made the list.",
      subtitle: 'JD-weighted match scoring with skill gaps, signals, and full explainability.',
      description: "GoGrabJob's role-fit engine doesn't just rank candidates — it shows exactly which skills match, which are gaps, and why each score was assigned, so every shortlist is defensible.",
      heroBg: 'linear-gradient(150deg, #F0FDF4 0%, #DCFCE7 35%, #F0FDF4 65%, #ECFDF5 100%)',
      accentText: 'text-emerald-600',
      stats: [
        { value: '94%', label: 'Match accuracy (first-pass)' },
        { value: 'Gap-level', label: 'Explainability depth' },
        { value: 'JD-weighted', label: 'Scoring methodology' },
        { value: 'Bias-free', label: 'Demographic signals excluded' },
      ],
      sections: [
        {
          heading: 'How Scoring Works',
          bullets: [
            'Parses JD into weighted skill, experience, and requirement clusters',
            'Each candidate resume scored against the same structured rubric',
            'Weights adjustable per role by recruiter or hiring manager',
            'Scores recalculate instantly when JD is updated',
            'Bulk scoring — process hundreds of resumes in minutes',
            'Score explainer card generated for every candidate',
          ],
        },
        {
          heading: 'Skill Gap Analysis',
          bullets: [
            "Green / amber / red per skill requirement on every profile",
            'Gap summary in plain language — no jargon',
            'Suggested probing questions auto-generated from gaps',
            'Comparison view across shortlisted candidates side-by-side',
            'Historical fit data improves model per role type',
            'Exportable shortlist report for client or HM review',
          ],
        },
        {
          heading: 'Trust & Compliance',
          bullets: [
            'No demographic data used in scoring',
            'Recruiter can override any score with documented reason',
            'Full audit log of who viewed and actioned each score',
            'GDPR-compatible — score data tied to lawful processing basis',
          ],
        },
      ],
    }} />
  );
}
